import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import Helmet from 'react-helmet';

import CountUp from "react-countup";
import {DateRangePicker} from "react-dates";
import moment from "moment";
import Notification from "../../components/Notification";
import {Line} from 'react-chartjs-2';

class Stats extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            isError:false,
            report:false,
            startDateId:'1',
            stopDateId:'2',
            initialStart:moment(moment().subtract(30, 'days')),
            initialEnd:moment(),
            startDate:moment(moment().subtract(30, 'days')),
            endDate:moment(),
        }

    }

    onDatesChange = ({ startDate, endDate }) => {
        this.setState({ startDate, endDate });
        this.get(startDate,endDate);
    }

    onFocusChange = (focusedInput) => {
        this.setState({ focusedInput });
    }

    get(from = false,to = false) {

        if(!from) {
            from = this.state.startDate;
        }
        if(!to) {
            to = this.state.endDate;
        }
        this.setState({
            'isLoading':true,
        });

        if(!to || !from) {
            this.setState({
                startDate:this.state.initialEnd,
                endDate:this.state.initialStart
            });

            Notification.error('Error: Invalid date, resetting to last month.');
            to = this.state.initialEnd;
            from = this.state.initialStart;
        }

        axios.get(`/stats?type=${this.props.router.params.type}&id=${this.props.router.params.id}`, {
            params: {
                'from':moment(from).format('YYYY-MM-DD'),
                'to':moment(to).format('YYYY-MM-DD')
            }
        })
            .then((res) => {
                this.setState({
                    isError:false,
                    isLoading:false,
                    report:res.data
                });
            }).catch(() => {
            this.setState({
                isError:true,
            })
        });
    }

    generateGraphData = () => {
        let graph = {
            labels:[],
            datasets:[
                {
                    label: 'Revenue',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(0,21,123,0.4)',
                    borderColor: 'rgba(0,21,123,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(0,21,123,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(0,21,123,1)',
                    pointHoverBorderColor: 'rgba(0,21,123,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: []
                },
                {
                    label: 'Orders',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(1,87,155,0.4)',
                    borderColor: 'rgba(1,87,155,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(1,87,155,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba(1,87,155,1)',
                    pointHoverBorderColor: 'rgba(1,87,155,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: []
                },
                {
                    label: 'Clicks',
                    fill: false,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(66,66,66,0.4)',
                    borderColor: 'rgba(66,66,66,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(66,66,66,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgba66,66,66,1)',
                    pointHoverBorderColor: 'rgba(66,66,66,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 1,
                    pointHitRadius: 10,
                    data: []
                },
            ]
        };

        for(let i in this.state.report.graph) {
            graph.labels.push(i);
            graph.datasets[0].data.push((this.state.report.graph[i].revenue/100));
            graph.datasets[1].data.push(this.state.report.graph[i].orders);
            graph.datasets[2].data.push(this.state.report.graph[i].clicks);
        }
        return graph;

    }

    componentDidMount() {
        this.get();
    }

    render() {
        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }

        return (
            <div className="full-height">
                <div className="page-header">
                    <span className="page-title"><i className="icon wb-graph-up"></i> Statistics</span>
                    <div className="page-header-actions">
                        <DateRangePicker
                            startDateId={this.state.startDateId}
                            endDateId={this.state.stopDateId}
                            onDatesChange={this.onDatesChange}
                            onFocusChange={this.onFocusChange}
                            startDateId="start_date"
                            endDateId="end_date"
                            small={true}
                            focusedInput={this.state.focusedInput}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            isOutsideRange={() => {return false}}
                            anchorDirection="left"
                            showDefaultInputIcon
                        />
                    </div>
                </div>
                <div className="page-content">
                    <Helmet title="Stats | Crall.io" />

                    <div className="row">
                        <div className="col-sm-3">
                            <div className="card card-block p-30">
                                <div className="card-watermark blue-grey-500 font-size-60 m-15">
                                    <i className="icon wb-thumb-up" aria-hidden="true"></i>
                                </div>
                                <div className="counter counter-md counter-inverse text-xs-left">
                                    <div className="counter-number-group ">
                                        <span className={`counter-number blue-grey-500`}><CountUp start={0} end={this.state.report.clicks} duration={2} /></span>
                                    </div>
                                    <div className="counter-label blue-grey-500 text-capitalize">Clicks</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-3">
                            <div className="card card-block p-30">
                                <div className="card-watermark blue-grey-500 font-size-60 m-15">
                                    <i className="icon wb-shopping-cart" aria-hidden="true"></i>
                                </div>
                                <div className="counter counter-md counter-inverse text-xs-left">
                                    <div className="counter-number-group ">
                                        <span className={`counter-number blue-grey-500`}><CountUp start={0} end={this.state.report.orders} duration={2} /></span>
                                    </div>
                                    <div className="counter-label blue-grey-500 text-capitalize">Orders</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-3">
                            <div className="card card-block p-30">
                                <div className="card-watermark blue-grey-500 font-size-60 m-15">
                                    <i className="icon wb-payment" aria-hidden="true"></i>
                                </div>
                                <div className="counter counter-md counter-inverse text-xs-left">
                                    <div className="counter-number-group ">
                                        <span className={`counter-number blue-grey-500`}><CountUp start={0} end={(this.state.report.revenue/100)} duration={2} /></span>
                                    </div>
                                    <div className="counter-label blue-grey-500 text-capitalize">Revenue</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-3">
                            <div className="card card-block p-30">
                                <div className="card-watermark blue-grey-500 font-size-60 m-15">
                                    <i className="icon wb-stats-bars" aria-hidden="true"></i>
                                </div>
                                <div className="counter counter-md counter-inverse text-xs-left">
                                    <div className="counter-number-group ">
                                        <span className={`counter-number blue-grey-500`}><CountUp start={0} end={this.state.report.conversion_rate} duration={2} />%</span>
                                    </div>
                                    <div className="counter-label blue-grey-500 text-capitalize">Conversion rate</div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="col-sm-12 p-0">
                        <div className="card card-block p-30">
                            <Line data={this.generateGraphData} />
                        </div>
                    </div>
                </div>
            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Stats = connect(mapStateToProps,mapDispatchToProps)(Stats);
export default Stats;



// WEBPACK FOOTER //
// ./containers/stats/stats.js